import { MonthCalendarHead } from './MonthCalendarHead/MonthCalendarHead';
import { CalendarGrid } from './CalendarGrid/CalendarGrid';

export const CalendarMonth = () => {
  return (
    <>
      <MonthCalendarHead />
      <CalendarGrid />
    </>
  );
};
